import { BaseApi } from './base.api'
import { DEFAULT_PAGE_SIZE, METHOD_AXIOS } from '../utils/constant'

export class NotificationApi extends BaseApi {
	constructor() {
		super('api/notification')
	}

	async sendNotification() {
		return this.post(`/custom-all`, {})
	}
	async addNotification(data) {
		const rs = await this.methodWithFormDataUrlEncoded(
			`/send-notification`,
			data,
			METHOD_AXIOS.POST
		)
		return rs
	}

	async getNotifications(page = 0, pageSize = DEFAULT_PAGE_SIZE) {
		const searchParams = new URLSearchParams({
			pageNum: String(page),
			pageSize: String(pageSize),
		})
		return this.get(`?${searchParams.toString()}`)
	}
}

export class NotificationAdminApi extends BaseApi {
	constructor() {
		super('api/admin/notification')
	}

	async getNotifications(page = 0, pageSize = DEFAULT_PAGE_SIZE, filters = {}) {
		const searchParams = new URLSearchParams({
			pageNum: String(page),
			pageSize: String(pageSize),
		})
		if (Array.isArray(filters.types) && filters.types.length > 0) {
			searchParams.set('types', filters.types.join(','))
		} else if (
			typeof filters.types === 'string' &&
			filters.types.trim() !== ''
		) {
			searchParams.set('types', filters.types.trim())
		}
		return this.get(`?${searchParams.toString()}`)
	}

	async sendCustomNotification(data) {
		return this.methodWithFormDataUrlEncoded(
			`/custom/send`,
			data,
			METHOD_AXIOS.POST
		)
	}

	async getCustomNotificationSendJobStatus(jobID) {
		return this.get(`/custom/send/jobs/${jobID}`)
	}

	async cancelCustomNotificationSendJob(jobID) {
		return this.post(`/custom/send/jobs/${jobID}/cancel`, {})
	}

	async deleteNotification(id) {
		return this.delete(`/${id}`)
	}

	async deleteManyNotifications(ids = []) {
		return this.delete('', { ids })
	}
}
